var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2308 3.80046L30 12.9698L21.2308 22.1995C16.3846 27.2668 8.48077 27.2668 3.63462 22.1995C-1.21154 17.1323 -1.21154 8.86775 3.63461 3.80046C8.48077 -1.26682 16.3846 -1.26682 21.2308 3.80046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.5C17.1421 5.5 20.5 8.85786 20.5 13C20.5 17.1421 17.1421 20.5 13 20.5C8.85786 20.5 5.5 17.1421 5.5 13C5.5 8.85786 8.85786 5.5 13 5.5ZM15.2294 13.7505H10.7707C10.8539 15.2532 11.1844 16.6212 11.69 17.6324C12.161 18.5743 12.6642 19 13.0001 19C13.3359 19 13.8391 18.5743 14.3101 17.6324C14.8157 16.6212 15.1462 15.2532 15.2294 13.7505ZM18.9535 13.7507L16.7314 13.7509C16.6407 15.5764 16.2227 17.2092 15.5965 18.4114C17.3951 17.5462 18.6964 15.8106 18.9535 13.7507ZM9.26856 13.7509L7.04651 13.7507C7.30364 15.8106 8.60494 17.5461 10.404 18.4109C9.81651 17.2843 9.41238 15.7788 9.28939 14.0909L9.26856 13.7509V13.7509ZM10.4035 7.58859L10.3839 7.59886C8.59507 8.46689 7.3024 10.1974 7.04641 12.2499L9.2685 12.2498C9.35916 10.4241 9.77718 8.79098 10.4035 7.58859ZM13 7L12.9391 7.00444C12.6051 7.05187 12.1332 7.48109 11.69 8.36752C11.1843 9.37896 10.8538 10.7472 10.7707 12.2502H15.2294C15.1463 10.7472 14.8158 9.37896 14.31 8.36752C13.8391 7.42568 13.3359 7 13 7ZM15.596 7.58912L15.6129 7.6204C16.2302 8.81981 16.6417 10.4404 16.7315 12.2503L18.9536 12.25C18.6967 10.1898 17.3953 8.45394 15.596 7.58912Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 30,
    fill: "white",
    transform: "translate(0 26) rotate(-90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.90152dd0.svg";
export { ForwardRef as ReactComponent };